export enum E_EDITOR_CUSTOM_EVENT {
  SAVE_DESIGN = 'editor:save-design',
  SAVE_DESIGN_SUCCESS = 'editor:save-design-success',
  GET_PRODUCT_ITEMS = 'editor:get-product-items',
  GET_PRODUCT_ITEMS_SUCCESS = 'editor:get-product-items-success',
  REMOVE_ITEMS_GROUP = 'editor:remove-items-group',
  REMOVE_ITEMS_GROUP_SUCCESS = 'editor:remove-items-group-success',
  EDITOR_LOAD = 'editor:load',
  EDIT_ITEM_TEXT = 'editor:edit-item-text'
};